module.exports = __webpack_public_path__ + "img/4.bf815fc4.jpg";